export function currentDashboardReturnPath(pathname: string, search: string): string | null {
  if (pathname !== "/dashboard") return null;
  return `${pathname}${search}`;
}

export function safeAppReturnPath(value: string | null, origin: string): string | null {
  if (!value) return null;
  try {
    const url = new URL(value, origin);
    if (url.origin !== origin) return null;
    if (url.pathname === "/dashboard") return `${url.pathname}${url.search}${url.hash}`;
    if (url.pathname !== "/ushqimi-mujor") return null;
    const schoolId = url.searchParams.get("schoolId");
    if (schoolId !== "bgt-prishtine" && schoolId !== "bgt-prishtine-ii" && schoolId !== "bgt-prizren") return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export const safeDashboardReturnPath = safeAppReturnPath;
